import http from '@/vendor/axios'

export function getCycles () {
  // const url = '/api/okr.cycle/'
  const url = '/api/okr.cycle/?filter=[["state","=","start"]]'
  return http.get(url)
    .then(res => res.result)
}
